import { LocalStorageAPI } from '../LocalStoreApi';
import { eLocalStorageTags } from '../eLocalStorageTags';
import { UUID } from '../../types/shared/UUID';

export interface ShortcutData {
  id: UUID;
  name: string;
  keyboardKey: string;
  search: string;
  description: string;
}
type CompleteShortcutData = Record<UUID, ShortcutData>;

export const checkForExistingShortcutSearchString = (
  locationSearch: string,
  existingShortcuts: CompleteShortcutData
) => {
  return Object.values(existingShortcuts)
    .map(({ search }) => search)
    .includes(locationSearch);
};

const url = 'pcDashboardCustomViews';
export const CustomViewsApi = LocalStorageAPI.injectEndpoints({
  endpoints: (build) => ({
    getCustomViews: build.query<CompleteShortcutData, void>({
      query: () => ({
        url,
        method: 'GET',
      }),
      providesTags: [{ type: eLocalStorageTags.CustomView, id: 'Object' }],
    }),
    setCustomViews: build.mutation<void, CompleteShortcutData>({
      query: (body) => ({
        url,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: eLocalStorageTags.CustomView, id: 'Object' }],
    }),
  }),
});

export const { useGetCustomViewsQuery, useSetCustomViewsMutation } = CustomViewsApi;
